module.exports = __webpack_public_path__ + "img/menu.7014f04b.svg";